import React from 'react';

import {css} from 'emotion';
import {get, replace} from 'lodash-es';
import PropTypes from 'prop-types';

import NavMenuList from '../../NavMenuList';
import NavMenuListItem from '../../NavMenuList/NavMenuListItem';
import {AnchorWithTrackEvent} from '../GlobalNav';
import {
  ELA_CONSTANTS,
  EN_ESPANOL_CONSTANTS,
  NEWS_CONSTANTS,
  SCIENCE_CONSTANTS,
  SOCIAL_STUDIES_CONSTANTS,
} from './constants';
import {
  listBufferBottom,
  listItemLinkStyle,
  marginBottomOverride,
  menuHeadingStyle,
  ulPaddingOverride
} from './style';
import {activePageCheck} from './utils';

const propTypes = {
  collections: PropTypes.array,
  history: PropTypes.object,
  userId: PropTypes.number,
  isNewGlobalNav: PropTypes.bool
};

export const BrowseDrawer = (props) => {
  const {
    collections,
    history,
    isNewGlobalNav = false,
  } = props;


  const activeURL = history.location.pathname;

  const licensedCustomCollectionItems = collections.filter((collection) => {
    return collection.is_custom && get(collection.root_text_set, 'id') && collection.is_branded_product;
  }).map((collection) => {
    const {root_text_set, subject, title} = collection;
    const formattedSubject = replace(subject, '_', '-');
    const formattedURL = `/subject/${formattedSubject}/${root_text_set.id}`;
    return (
      <NavMenuListItem
        key={title}
        isHighlighted={activePageCheck(formattedURL, activeURL)}
      >
        <AnchorWithTrackEvent
          aria-current={activePageCheck(formattedURL, activeURL) ? 'page' : null}
          className={css(listItemLinkStyle)}
          eventName={`${title}-Navigate`}
          eventProperties={{
            description: `Browse drawer ${title} link `
          }}
          href={formattedURL}
        >
          {title}
        </AnchorWithTrackEvent>
      </NavMenuListItem>
    );
  });

  const socialEmotionalLearningItem = collections.filter((collection) => {
    return collection.slug === 'social-emotional-learning';
  }).map((collection) => {
    const {root_text_set, subject, title} = collection;
    const formattedSubject = replace(subject, '_', '-');
    const formattedURL = `/subject/${formattedSubject}/${root_text_set.id}`;
    return (
      <NavMenuListItem
        key={title}
        isHighlighted={activePageCheck(formattedURL, activeURL)}
      >
        <AnchorWithTrackEvent
          aria-current={activePageCheck(formattedURL, activeURL) ? 'page' : null}
          className={css(listItemLinkStyle)}
          eventName={`${title}-Navigate`}
          eventProperties={{
            description: `Browse drawer ${title} link `
          }}
          href={formattedURL}
        >
          {title}
        </AnchorWithTrackEvent>
      </NavMenuListItem>
    );
  });

  const lgbtqiaItem = collections.filter((collection) => {
    return collection.slug === 'lgbtqia-ss';
  }).map((collection) => {
    const {root_text_set, subject, title} = collection;
    const formattedSubject = replace(subject, '_', '-');
    const formattedURL = `/subject/${formattedSubject}/${root_text_set.id}`;
    return (
      <NavMenuListItem
        key={title}
        isHighlighted={activePageCheck(formattedURL, activeURL)}
      >
        <AnchorWithTrackEvent
          aria-current={activePageCheck(formattedURL, activeURL) ? 'page' : null}
          className={css(listItemLinkStyle)}
          eventName={`${title}-Navigate`}
          eventProperties={{
            description: `Browse drawer ${title} link `
          }}
          href={formattedURL}
        >
          {title}
        </AnchorWithTrackEvent>
      </NavMenuListItem>
    );
  });

  return (
    <>
      {
        licensedCustomCollectionItems.length > 0 ?
          <>
            <h3 className={css(menuHeadingStyle)}>FOR YOUR SCHOOL</h3>
            <NavMenuList additionalClassName={css(ulPaddingOverride)}>
              {licensedCustomCollectionItems}
            </NavMenuList>
          </>
          : null
      }
      {!isNewGlobalNav && (<h3 className={css(menuHeadingStyle)}>SUBJECT AREAS</h3>)}
      <NavMenuList additionalClassName={css(ulPaddingOverride)}>
        {!isNewGlobalNav && (<NavMenuListItem
          key={ELA_CONSTANTS.name}
          isHighlighted={activePageCheck(ELA_CONSTANTS.slug, activeURL)}
                             >
          <AnchorWithTrackEvent
            aria-current={activePageCheck(ELA_CONSTANTS.slug, activeURL) ? 'page' : null}
            className={css(listItemLinkStyle)}
            eventName={`${ELA_CONSTANTS.name}-Navigate`}
            eventProperties={{
              description: `Browse drawer ${ELA_CONSTANTS.name} link `
            }}
            href={ELA_CONSTANTS.slug}
          >
            {ELA_CONSTANTS.name}
          </AnchorWithTrackEvent>
        </NavMenuListItem>)}
        {!isNewGlobalNav && (<NavMenuListItem
          key={SCIENCE_CONSTANTS.name}
          isHighlighted={activePageCheck(SCIENCE_CONSTANTS.slug, activeURL)}
                             >
          <AnchorWithTrackEvent
            aria-current={activePageCheck(SCIENCE_CONSTANTS.slug, activeURL) ? 'page' : null}
            className={css(listItemLinkStyle)}
            eventName={`${SCIENCE_CONSTANTS.name}-Navigate`}
            eventProperties={{
              description: `Browse drawer ${SCIENCE_CONSTANTS.name} link `
            }}
            href={SCIENCE_CONSTANTS.slug}
          >
            {SCIENCE_CONSTANTS.name}
          </AnchorWithTrackEvent>
        </NavMenuListItem>)}
        {!isNewGlobalNav && (<NavMenuListItem
          key={SOCIAL_STUDIES_CONSTANTS.name}
          isHighlighted={activePageCheck(SOCIAL_STUDIES_CONSTANTS.slug, activeURL)}
                             >
          <AnchorWithTrackEvent
            aria-current={activePageCheck(SOCIAL_STUDIES_CONSTANTS.slug, activeURL) ? 'page' : null}
            className={css(listItemLinkStyle)}
            eventName={`${SOCIAL_STUDIES_CONSTANTS.name}-Navigate`}
            eventProperties={{
              description: `Browse drawer ${SOCIAL_STUDIES_CONSTANTS.name} link `
            }}
            href={SOCIAL_STUDIES_CONSTANTS.slug}
          >
            {SOCIAL_STUDIES_CONSTANTS.name}
          </AnchorWithTrackEvent>
        </NavMenuListItem>)}
        {lgbtqiaItem}
        {socialEmotionalLearningItem}

      </NavMenuList>
      <h3 className={css(menuHeadingStyle)}>ALL TOPICS</h3>
      <NavMenuList additionalClassName={css(ulPaddingOverride)}>

        <NavMenuListItem
          key={NEWS_CONSTANTS.name}
          isHighlighted={activePageCheck(NEWS_CONSTANTS.slug, activeURL)}
        >
          <AnchorWithTrackEvent
            aria-current={activePageCheck(NEWS_CONSTANTS.slug, activeURL) ? 'page' : null}
            className={css(listItemLinkStyle)}
            eventName={`${NEWS_CONSTANTS.name}-Navigate`}
            eventProperties={{
              description: `Browse drawer ${NEWS_CONSTANTS.name} link `
            }}
            href={NEWS_CONSTANTS.slug}
          >
            {NEWS_CONSTANTS.name}
          </AnchorWithTrackEvent>
        </NavMenuListItem>
      </NavMenuList>
      <h3 className={css(menuHeadingStyle)}>LANGUAGES</h3>
      <NavMenuList additionalClassName={css(ulPaddingOverride)}>
        <NavMenuListItem
          key={EN_ESPANOL_CONSTANTS.name}
          isHighlighted={activePageCheck(EN_ESPANOL_CONSTANTS.slug, activeURL)}
        >
          <AnchorWithTrackEvent
            aria-current={activePageCheck(EN_ESPANOL_CONSTANTS.slug, activeURL) ? 'page' : null}
            className={css(listItemLinkStyle, marginBottomOverride)}
            eventName={`${EN_ESPANOL_CONSTANTS.name}-Navigate`}
            eventProperties={{
              description: `Browse drawer ${EN_ESPANOL_CONSTANTS.name} link `
            }}
            href={EN_ESPANOL_CONSTANTS.slug}
            lang={EN_ESPANOL_CONSTANTS.lang}
          >
            {EN_ESPANOL_CONSTANTS.name}
          </AnchorWithTrackEvent>
        </NavMenuListItem>
        <div className={css(listBufferBottom)} />
      </NavMenuList>
    </>
  );
};

BrowseDrawer.propTypes = propTypes;
export default BrowseDrawer;
